<template>
  <div class="product-report product-report--query-grid">
    <!-- 查询条件 -->
    <div class="product-report-query">
      <Row
        :gutter="20"
        class="query-conditions"
      >
        <Col
          v-show="queryFieldVisibility.date"
          :span="queryColSpan"
          class="query-item"
        >
          <DatePicker
            style="width: 100%"
            v-model="date"
            @change="handleDatePickerChange"
          />
        </Col>
        <Col
          v-show="queryFieldVisibility.budget_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <!-- <Input
          placeholder="输入聚合名称或产品名称"
          v-model="name"
          clearable
          style="width: 100%;"/> -->
          <Select
            v-model="budget_ids"
            placeholder="输入聚合名称"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchAggregations"
          >
            <Option
              v-for="item in aggregationsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>
        <Col
          v-show="queryFieldVisibility.product_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <!-- <Input
          placeholder="输入聚合名称或产品名称"
          v-model="name"
          clearable
          style="width: 100%;"/> -->
          <Select
            v-model="product_ids"
            placeholder="输入产品名称"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchProducts"
          >
            <Option
              v-for="item in productsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>
        <Col
          v-show="queryFieldVisibility.sale_type"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="sale_type"
            placeholder="请选择预算类型"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in budgetOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.account_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Input
          placeholder="输入广告主id, 多个id用英文逗号分隔"
          v-model="account_ids"
          clearable
          style="width: 100%;"/>
        </Col>

        <Col
          v-show="queryFieldVisibility.agent_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Input
          placeholder="输入代理商id, 多个id用英文逗号分隔"
          v-model="agent_ids"
          clearable
          style="width: 100%;"/>
        </Col>

        <Col
          v-show="queryFieldVisibility.sale_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <!-- <Input
          placeholder="输入销售名称/所属"
          v-model="sale_name"
          clearable
          style="width: 100%;"/> -->
          <Select
            v-model="sale_ids"
            placeholder="输入销售名称/所属"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchSales"
          >
            <Option
              v-for="item in salesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.product_series_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="product_series_ids"
            placeholder="请选择产品系"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            reserve-keyword
            collapse-tags
            :remote-method="handleSearchSeries"
          >
            <Option
              v-for="item in productSeriesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.customer_cate"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="customer_cate"
            placeholder="请选择客户类目"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in kaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.task_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="task_ids"
            placeholder="输入任务名称"
            style="width: 100%;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchTasks"
          >
            <Option
              v-for="item in taskOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.is_new_customer"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="is_new_customer"
            class="comp"
            clearable
            placeholder="新老客类型"
            style="width: 100%;"
          >
            <Option
              v-for="item in IS_NEW_CUSTOMER_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.dimension"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="dimension"
            class="comp"
            @change="handleAggregatedTypeChange"
            placeholder="汇总方式"
            style="width: 100%;"
          >
            <Option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.value === 'hour' && !hourUseable"
            />
          </Select>
        </Col>

        <!-- <Col
          v-show="isAdmin && queryFieldVisibility.is_new_customer"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="budget_status"
            class="comp"
            clearable
            placeholder="请选择聚合状态"
            style="width: 100%;"
          >
            <Option
              v-for="item in AGGREGATION_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col> -->

        <Col
          :span="queryActionSpan"
          class="query-item query-item--actions"
        >
          <div class="query-buttons">
            <Button
              plain
              type="primary"
              @click="handleReset"
            >
              重置
            </Button>
          <Button
            @click="handleSearchData"
              type="primary"
            >
            查询
          </Button>
          <Button
            v-if="showQueryToggle"
            type="text"
            class="query-toggle"
            @click="toggleQueryExpand"
          >
            {{ queryExpanded ? '收起' : '展开' }}
            <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </Button>
          </div>
        </Col>
      </Row>

      <!-- <span
        v-if="lastUpdateTime"
        class="product-report-lastUpdateTime"
      >
        最新更新时间：{{ lastUpdateTime }}
      </span> -->
    </div>

    <!-- 汇总数据 -->
    <!-- <div
      v-loading="summaryLoading"
      class="product-report-summary clearfix"
    >
      <DataCard
        v-for="item in summary"
        :key="item.key"
        class="product-report-card"
        :dataSource="item"
        @setting-click="handleDataCardSettingClick"
        @num-click="handleDataCardNumClick"
      />
    </div> -->

    <StopDay
      v-model="stopDays"
      :visible.sync="stopDayVisible"
      @confirm="handleStopDayConfirm"
    />

    <!-- 我的业绩 -->
    <div class="product-report-chart">
      <Title text="我的业绩" />

      <Tabs
        v-model="dimension"
        class="product-report-tabs"
        @tab-click="handleTabsClick"
      >
        <TabPane
          v-for="item in summary"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>

      <div class="product-report-tabs-header">
        <div>
          <span>展示指标：</span>
          <Select
            v-model="field"
            @change="handleFieldSelectChange"
          >
            <Option
              v-for="item in options"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            />
          </Select>
        </div>

        <RadioGroup
          v-model="summaryType"
          @change="handleSummaryTypeChange"
        >
          <RadioButton label="all">汇总显示</RadioButton>
          <RadioButton label="top">TOP10聚合</RadioButton>
        </RadioGroup>
      </div>

      <div v-loading="chartLoading">
        <Chart
          :dataSource="rawChartData"
          :field="field"
          :type="summaryType"
        />
      </div>
    </div>

    <!-- 详细数据 -->
    <div class="product-report-detail">
      <Title text="详细数据" />
      <div v-loading="tableLoading">
        <CustomTable
          v-if="hasUserInfo"
          class="product-report-detail-table"
          topic="performance_detail"
          :args="downloadArgs"
          :dataSource="rawTableData"
          :customColumns="CustomColumns"
          :fixedColumns="fixedColumns"
          :columnDialogStyle="{width: '800px'}"
          @created="handleCustomTableCreated"
          @download="handleCustomTableDownload"
          @change-columns="handleCustomTableColumnsChange"
          @sort-change="handleCustomTableSortChange"
          @filter-x-change="handleCustomTableFilterChange"
          @current-change="handleCustomTableCurrentChange"
          @size-change="handleCustomTableSizeChange"
        >
          <template v-slot:column="{ data: d }">
            <a
              v-if="d.field.key === 'product_name'"
              class="product-report-redirect"
              @click="handleProductNameClick(d.row)"
            >
              {{ d.value }}
            </a>

            <div v-else-if="checkIsHover(d.field.key, d)">
              <div v-if="dimensionBy === 'day'">
                <Tooltip>
                  <div slot="content" v-if="dimensionBy === 'day'">
                    <div>对比日期：{{ d.value.before_date }}</div>
                    <div>对比日期的值：{{ d.value.before_value }}</div>
                    <div>差值：{{ d.value.diff_value }}</div>
                  </div>
                  <div>
                    <span>{{ d.value.value }}</span>
                    <br>
                    <span :class="`product-report-${checkRate(d.value.rate)}`">
                      ({{ d.value.rate }})
                    </span>
                  </div>
                </Tooltip>
              </div>
              <div v-else>
                <div>
                    <span>{{ d.value.value }}</span>
                    <!-- <br>
                    <span :class="`product-report-${checkRate(d.value.rate)}`">
                      ({{ d.value.rate }})
                    </span> -->
                  </div>
              </div>


            </div>


            <span v-else-if="d.field.key === 'sale_type'">{{ d.value == 1 ? '直投' : (d.value == 2 ? '渠道' : '') }}</span>
            <span v-else-if="d.field.key === 'customer_cate '">{{ d.value == 1 ? 'KA' : '非KA' }}</span>
            <span v-else>{{ d.value || '-'}}</span>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  Tabs,
  TabPane,
  Select,
  Input,
  Row,
  Col,
  Option,
  RadioGroup,
  RadioButton,
  Tooltip,
  Button
} from 'element-ui';

import Title from '@/components/Title';
import DatePicker from '@/components/DatePicker2/Index';
import CustomTable from '@/components/CustomTable/Index';
import DataCard from './components/DataCard/Index';
import StopDay from './components/StopDay/Index';
import Chart from './components/Chart/Index';

import shortcuts from '@/config/shortcuts2';
import { getFieldsByList } from '@/config/columns/';
import requestMixin from './mixins/request';
import { fields, customColumns, customColumns2, fixedColumns, fieldWithDiff } from './config/';
import { isEmpty } from '@/common/util';
import * as $cache from '@/common/cache';
import dateOptions from './config/date';
import Request from '@/core/QuRequest';
import productReport from '../../../router/productReport';
import { debounce, throttle } from 'lodash';
import queryGridByContainer from '@/common/js/queryGridByContainer';
const req = new Request();

const createDefaultDateRange = () => shortcuts.last7Days.data.map(date => date.clone());

const DEFAULT_QUERY_ORDER = 'day desc';

const createDefaultFilterState = () => ({
  date: createDefaultDateRange(),
  dimension: 'day',
  dimensionBy: 'day',
  budget_ids: [],
  product_ids: [],
  sale_type: undefined,
  account_ids: '',
  agent_ids: '',
  task_ids: [],
  sale_ids: [],
  customer_cate: undefined,
  product_series_ids: [],
  is_new_customer: undefined,
  budget_status: undefined,
});

export default {
  components: {
    Tabs,
    TabPane,
    Select,
    Input,
    Row,
    Col,
    Option,
    RadioGroup,
    RadioButton,
    Tooltip,
    Button,
    DatePicker,
    DataCard,
    StopDay,
    Title,
    Chart,
    CustomTable,
  },

  mixins: [requestMixin, queryGridByContainer],

  data() {
    return {
      // 查询时间段
      // 默认7天
      hourUseable: true,
      date: createDefaultDateRange(),
      // date: [moment('2019-11-20'), moment('2019-11-23')],
      // 最后更新时间
      lastUpdateTime: '',
      // 当前维度
      dimension: 'online_product',
      // 当前指标
      field: 'cost_total',

      // 汇总信息
      summary: null,
      // 汇总信息 loading
      summaryLoading: true,
      // 停投天数
      // 默认为查询时间范围的差值
      stopDays: 5,
      // 是否显示停投天数对话框
      stopDayVisible: false,

      // 备选指标列表
      options: getFieldsByList(fields),
      // 汇总类型
      summaryType: 'all',
      // 图表数据 loading
      chartLoading: true,
      // 图表原始数据
      rawChartData: {},

      // 表格 loading
      tableLoading: true,
      // 当前页码
      page: 1,
      // 每页数量
      pageSize: 10,
      // 排序
      order: DEFAULT_QUERY_ORDER,
      // 过滤
      rawfilters: {},
      // 指标列表
      fields: [],
      // 固定列
      fixedColumns,
      // 表格原始数据
      rawTableData: {},
      dateOptions,
      IS_NEW_CUSTOMER_OPTIONS: [
        {label: '新客', value: 1},
        {label: '老客', value: 0},
      ],
      AGGREGATION_OPTIONS: [
        {label: '正常', value: 1},
        {label: '待处理', value: 0},
      ],
      budgetOptions: [
        {label: '直投', value: 1},
        {label: '渠道', value: 2},
      ],
      kaOptions: [
        { value: 1, label: 'KA' },
        { value: 0, label: '非KA' },
      ],
      productSeriesOptions: [

      ],
      salesOptions: [],
      aggregationsOptions: [],
      productsOptions: [],
      ...createDefaultFilterState(),
      taskOptions: [],
      userInfo: {},
      queryExpanded: true,
      is_new_customer: undefined,
    };
  },
  watch: {
      date (n, o) {
          if(n && n.length === 2) {
            let startDate = moment(n[0]).format('YYYY-MM-DD');
            let endDate = moment(n[1]).format('YYYY-MM-DD');
            let flag = this.isDateRangeIncludeToday(startDate, endDate);

            if(this.dimension === 'hour' && !flag) {
              this.dimension = 'day'
              this.dimensionBy = 'day'
            }

            if(!flag) {
              this.hourUseable = false;
            } else {
              this.hourUseable = true;
            }
          }
      }
  },

  computed: {
    isAdmin() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("30")
      }
      return false
    },
    isChannelSale() {
      // 1:超管，2是直客销售  3是直客销售leader
      return Boolean(this.userInfo && this.userInfo.is_channel_sale);
    },
    hasUserInfo() {
      return this.userInfo && this.userInfo.is_channel_sale !== undefined;
    },
    CustomColumns() {
      let _columns = this.isChannelSale ? customColumns2 : customColumns;
      // if (this.isAdmin) {
      //   _columns[0].children[3] = {
      //     key: 'budget_status',
      //     isSelected: true,
      //   }
      // }
      return _columns
    },

    // 所选时间范围差
    dateDiff() {
      const [start, end] = this.date;
      const diff = moment(start).diff(moment(end), 'days');
      return Math.abs(diff) + 1;
    },

    // 图表数据是否为空
    isChartDataEmpty() {
      const { date, list } = this.rawChartData;
      return !(isEmpty(date) && isEmpty(list));
    },

    filters() {
      const arr = [];
      Object.keys(this.rawfilters).forEach((key) => {
        const { type, min, max } = this.rawfilters[key];
        arr.push(`${type},${min},${max}`);
      });
      return arr;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns =
        remainder === 0
          ? this.queryColumnsPerRow
          : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      let fields = [
        'date',
        'budget_ids',
        'product_ids',
        'sale_type',
        'account_ids',
        'agent_ids',
        'sale_ids',
        'product_series_ids',
        'customer_cate',
        'task_ids',
        'dimension',
        'is_new_customer'
      ];

      // if(this.isAdmin) {
      //   return [...fields, 'budget_status']
      // }

      return fields
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    downloadArgs() {
      const params = this.getParams();
      params.order_by = this.order;
      params.dimension = 'common';
      params.fields = [...this.fields].join(',').replace('direct_sale2', 'direct_sale');
      params.filters = this.filters;
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      params.sale_type = this.sale_type;
      params.account_ids = this.account_ids;
      params.agent_ids = this.agent_ids;

      params.budget_ids = this.budget_ids ?  this.budget_ids.join(',') : '';
      params.sale_ids = this.sale_ids ?  this.sale_ids.join(',') : '';
      params.product_ids = this.product_ids ?  this.product_ids.join(',') : '';
      params.task_ids = this.task_ids ?  this.task_ids.join(',') : '';

      params.product_series_ids = this.product_series_ids ?  this.product_series_ids.join(',') : '';
      params.customer_cate = this.customer_cate;
      params.is_new_customer = this.is_new_customer;
      params.dimensionBy = this.dimensionBy;
      return params;
    },
  },

  created() {
    // this.summaryLoading = false;
    // this.chartLoading = false;
    // this.tableLoading = false;
    // this.querySummaryData();
    this.queryChartData();
    this.queryProductSeriesList();
    this.queryAggregations('');
    this.queryProducts('');
    this.queryProductSales('');
    this.queryTasks('');
    this.getUserInfo();
  },

  methods: {
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    isDateRangeIncludeToday(startDate, endDate) {
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0]; // 获取 'YYYY-MM-DD'

      const start = new Date(startDate);
      const end = new Date(endDate);

      // 设置时间到午夜，避免时间部分的影响
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      today.setHours(0, 0, 0, 0);

      return today >= start && today <= end;
    },
    handleSearchProducts(val){
      this.queryProducts(val);
      // throttle(this.queryProducts(val), 500)
    },
    handleSearchAggregations(val){
      this.queryAggregations(val);
      // throttle(this.queryAggregations(val), 500)
    },
    handleSearchSeries(val){
      this.queryProductSeries(val);
      // throttle(this.queryProductSeries(val), 500)
    },
    handleSearchSales(val){
      this.queryProductSales(val);
      // throttle(this.queryProductSales(val), 500)
    },
    handleSearchTasks(val) {
      this.queryTasks(val);
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    handleReset() {
      Object.assign(this, createDefaultFilterState(), {
        order: DEFAULT_QUERY_ORDER,
        page: 1,
        rawfilters: {},
      });
    },
    queryProductSeriesList() {
      this.queryProductSeries();
    },
    handleAggregatedTypeChange(val){
      this.dimensionBy = val;
    },
    // 修改查询时间段
    handleDatePickerChange() {
      // this.page = 1;
      // this.querySummaryData();
      // this.queryChartData();
      // this.queryTableData();
    },
    handleSearchData(){
      this.page = 1;
      // this.querySummaryData();
      this.queryChartData();
      this.queryTableData();
    },
    // 点击汇总卡片的设置按钮
    handleDataCardSettingClick() {
      this.stopDayVisible = true;
    },

    // 点击汇总卡片的蓝色数值
    handleDataCardNumClick(data) {
      this.dimension = data.key;
      this.handleTabsClick();
    },

    // 设置停投时间
    handleStopDayConfirm(day) {
      this.dimension = 'stop_product';
      this.queryStopProductSummary();
      this.handleTabsClick();
    },

    // 变更维度
    handleTabsClick() {
      this.page = 1;
      this.queryChartData();
      this.queryTableData();
    },

    // 变更指标
    handleFieldSelectChange() {
      this.queryChartData();
    },

    // 变更汇总类型
    handleSummaryTypeChange() {
      this.queryChartData();
    },

    // 表格下载
    handleCustomTableDownload() {
      this.download();
    },

    // 变更自定义列
    handleCustomTableColumnsChange(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    handleCustomTableCreated(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    // 点击产品名称
    handleProductNameClick(data) {
      const url = this.$router.resolve({
        path: '/product-report/exact-product',
        name: 'ProductReportExactProduct',
        query: {
          id: data.product_id,
          name: data.product_name,
          start: this.date[0].format('YYYY-MM-DD'),
          end: this.date[1].format('YYYY-MM-DD'),
        },
      });
      window.open(url.href, '_blank');
    },

    // 更改排序
    handleCustomTableSortChange(sort) {
      if (sort) {
        this.page = 1;
        this.order = sort;
        this.queryTableData();
      }
    },

    // 更改过滤
    handleCustomTableFilterChange(filter) {
      this.page = 1;
      const { type, min, max } = filter;
      if (min !== undefined && max !== undefined) {
        this.$set(this.rawfilters, type, filter);
      } else {
        this.$delete(this.rawfilters, type);
      }
      this.queryTableData();
    },

    // 更改页码
    handleCustomTableCurrentChange(current) {
      this.page = current;
      this.queryTableData();
    },

    // 更改每页数量
    handleCustomTableSizeChange(size) {
      this.pageSize = size;
      this.queryTableData();
    },

    // 当前单元格是否可以悬浮
    checkIsHover(key, d) {
      return fieldWithDiff.includes(key) && d.value;
    },

    // 判断是上涨还是下跌
    checkRate(rate) {
      return rate.indexOf('-') !== -1 ? 'bottom' : 'top';
    },

    // 查询汇总数据
    querySummaryData() {
      // this.summaryLoading = true;
      // this.querySummary();
    },

    // 查询折线图数据
    queryChartData() {
      this.chartLoading = true;
      if (this.summaryType === 'all') {
        this.queryMyPerformance();
      } else if (this.summaryType === 'top') {
        this.queryTopTen();
      }
    },

    // 查询表格数据
    queryTableData() {
      this.tableLoading = true;
      this.queryList();
    },
  },
};
</script>

<style lang="less" scoped>
.product-report {
  font-size: 14px;

  &-lastUpdateTime {
    color: #c0c4cc;
    margin-left: 16px;
  }

  &-summary {
    margin-top: 32px;
  }

  &-card {
    float: left;
    margin: 0 30px 30px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &-chart {
    margin-top: 32px;
  }

  &-tabs {
    margin-top: 32px;

    &-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 20px 0;
    }
  }

  &-detail {
    margin-top: 32px;

    &-table {
      margin-top: 32px;
    }
  }

  &-redirect {
    cursor: pointer;
    color: #2f9eff;
  }

  &-top {
    color: @crm-rise-color;
  }

  &-bottom {
    color: @crm-fall-color;
  }
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  justify-content: flex-end;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

/deep/ .el-dialog{
  min-width: 800px;
}
</style>
